import { createSlice } from "@reduxjs/toolkit"
import { KNOWLEDGEBASE } from "../../../constants/reducer_names"

const initialState = {
    knowledgeTab: false,
    knowledgeName: "",
    knowledgeDesc: "",
    kUrl: "",
    kwebId: 0,
    kWebSiteId: "",
    kChatArticleId: 0,
    kArticleList: [],
    kCategoryId: 0,
    CompanyType: "",
    kChatFlowId: "",
    previousWebsite: '',
    learningProgress: false,
    learningWebid: 0,
    learningWebsiteUrl: '',
    language:'English',
    knowledgeBaseRecords: [],
}


const knowledgeBaseSlice = createSlice({
    name: KNOWLEDGEBASE,
    initialState,
    reducers: {
        changeBaseTab: (state, { payload }) => {
            state.knowledgeTab = payload
        },
        storedKnowledgeBase: (state, { payload }) => {
            state.knowledgeName = payload.knowledgeName
            state.knowledgeDesc = payload.knowledgeDesc
            state.kUrl = payload.kUrl
            state.kwebId = payload.kwebId
            state.kWebSiteId = payload.kWebSiteId
            state.kChatArticleId = payload.kChatArticleId
            state.CompanyType = payload.CompanyType
            state.language=payload.language
        },
        storedArticleList: (state, { payload }) => {
            state.kArticleList = payload.kArticleList
        },
        setPreviousWebsite: (state, { payload }) => {
            state.previousWebsite = payload
        },
        setLearningProgress: (state, { payload }) => {
            state.learningProgress = payload
        },
        setLearningWebId: (state, { payload }) => {
            state.learningWebid = payload
        },
        setCurrentWebsiteUrl: (state, { payload }) => {
            state.kUrl = payload
        },
        setLearningWebsiteUrl: (state, { payload }) =>{
            state.learningWebsiteUrl = payload
        },
        storedCategoryID: (state, { payload }) => {
            state.kCategoryId = payload.kCategoryId
        },
        kChatFlowId: (state, { payload }) => {
            state.kChatFlowId = payload.kChatFlowId
        },
        setKnowledgeBaseRecords: (state, { payload }) => {
            state.knowledgeBaseRecords = payload
        },
        reset: () => { },
    }
})

export const knowledgeBaseActions = knowledgeBaseSlice.actions;
export default knowledgeBaseSlice.reducer; 